import { mapActions, mapState, mapWritableState } from "pinia"
import { useMainStore } from '@/store/main'


export default {
  computed: {
    ...mapState(useMainStore, ['isMobile']),
    ...mapWritableState(useMainStore, ['headerClicked'])
  },
  methods: {
    ...mapActions(useMainStore, ['toggleNav']),
    closeMobileNav() {
      if (this.isMobile)
        this.toggleNav()
    }
  }
}